import { useMemo, useState } from 'react';
import { ConfirmationModal, MenuItem, Select, TextField } from 'seagull';
import { useStoreActions } from "../../contexts";
import { useRestfulWrapper } from "../../hooks/useRestfulWrapper";
import { useUpdateRelationship } from "../../hooks/useUpdateRelationship";
import { agreementChangeModel, relationshipSummaryModel } from "../../models";
import { jsx as _jsx } from "react/jsx-runtime";
const fieldLabel = 'Assignee';
function AssigneeField(props) {
  const {
    members,
    sellerUserId,
    setSellerUserId
  } = props;
  const options = useMemo(() => members.filter(m => m.isAssignable(true)).map(m => ({
    value: m.id(),
    label: m.fullName()
  })), [members]);
  return /*#__PURE__*/_jsx(Select, {
    collapseHelperText: false,
    testId: "select-assignee",
    label: fieldLabel,
    value: sellerUserId,
    menuMaxHeight: 400,
    onChange: e => setSellerUserId(e.target.value),
    children: options.map(_ref => {
      let {
        value,
        label
      } = _ref;
      return /*#__PURE__*/_jsx(MenuItem, {
        value: value,
        testId: "select-assignee-option-".concat(value),
        children: label
      }, value);
    })
  });
}
export default function ChangeAssigneeModal(props) {
  const {
    relationship,
    dismissModal,
    onSuccess: _onSuccess
  } = props;
  const {
    api
  } = useStoreActions();
  const updateRelationship = useUpdateRelationship();
  const {
    loading,
    data,
    renderRestfulState
  } = useRestfulWrapper({
    fetch: () => Promise.all([api.member.getAll(), api.relationship.get(relationship.id)])
  });
  const [sellerUserId, setSellerUserId] = useState(relationshipSummaryModel.sellerId(relationship));
  async function changeAssignee() {
    if (!data) return;
    updateRelationship({
      id: relationship.id,
      version: data[1].version,
      changes: [agreementChangeModel.makeSellerChange(sellerUserId)],
      onSuccess: async () => {
        await _onSuccess();
        dismissModal();
      }
    });
  }
  return /*#__PURE__*/_jsx(ConfirmationModal, {
    title: "Change assignee",
    testId: "change-assignee-modal",
    textAlignCenter: false,
    primaryButtonLabel: "Save",
    secondaryButtonLabel: "Cancel",
    primaryButtonDisabled: loading,
    onPrimaryButtonClick: changeAssignee,
    onSecondaryButtonClick: () => dismissModal(),
    content: renderRestfulState({
      renderChild: _ref2 => {
        let {
          data
        } = _ref2;
        return /*#__PURE__*/_jsx(AssigneeField, {
          members: data[0].members,
          sellerUserId: sellerUserId,
          setSellerUserId: setSellerUserId
        });
      },
      renderLoader: () => /*#__PURE__*/_jsx(TextField, {
        collapseHelperText: false,
        testId: "select-assignee-placeholder",
        label: fieldLabel,
        value: "Loading..."
      })
    })
  });
}